//Creamos la variable de catalogos
const catalogos = {}

//Importación de librerias
import Comunes from '../js/catalogos/comun.js';
import PJ from '../js/catalogos/pj.js';
import Cuentas from '../js/catalogos/cuentas.js';
import Forseti from '../js/catalogos/forseti.js';
import SISEVA from '../js/catalogos/siseva.js';
import SIAP from '../js/catalogos/siap.js';
import TemisCivil from '../js/catalogos/temiscivil.js';
import ArchivoJudicial from '../js/catalogos/archivojudicial.js';
import SICPO from './catalogos/sicpo.js';
import SINOJ from '../js/catalogos/sinoj.js';
import SICCIJ from '../js/catalogos/siccij.js';
import SIPSIC from '../js/catalogos/sipsic.js';
import SICSEN from '../js/catalogos/sicsen.js';
import SIQA from '../js/catalogos/siqa.js';
import SIFA from '../js/catalogos/sifa.js';
import SICPE from '../js/catalogos/sicpe.js';
import SIVAC from '../js/catalogos/sivac.js';
import REGOP from '../js/catalogos/regop.js';

//Asignamos los datos en catalogos
crearLasRutasDeLosCatalogos(Comunes);
crearLasRutasDeLosCatalogos(PJ);
crearLasRutasDeLosCatalogos(Cuentas);
crearLasRutasDeLosCatalogos(Forseti);
crearLasRutasDeLosCatalogos(SISEVA);
crearLasRutasDeLosCatalogos(SIAP);
crearLasRutasDeLosCatalogos(TemisCivil);
crearLasRutasDeLosCatalogos(ArchivoJudicial);
crearLasRutasDeLosCatalogos(SINOJ);
crearLasRutasDeLosCatalogos(SICPO);
crearLasRutasDeLosCatalogos(SICCIJ);
crearLasRutasDeLosCatalogos(SIPSIC);
crearLasRutasDeLosCatalogos(SICSEN);
crearLasRutasDeLosCatalogos(SIQA);
crearLasRutasDeLosCatalogos(SIFA);
crearLasRutasDeLosCatalogos(SIVAC);
crearLasRutasDeLosCatalogos(REGOP);


//Exportamos los datos de común
export default catalogos;

//Se define la función que se encargara de hacer el listado de todos los paths
function crearLasRutasDeLosCatalogos(datosDeLosPaths) {
  for (let i = 0; i < datosDeLosPaths.length; i++) {
    if (catalogos[datosDeLosPaths[i].Proviene] === undefined || catalogos[datosDeLosPaths[i].Proviene] === null)
      catalogos[datosDeLosPaths[i].Proviene] = {}
  catalogos[datosDeLosPaths[i].Proviene][datosDeLosPaths[i].Nombre] = datosDeLosPaths[i].datos;

  }
  //console.log(catalogos);
}



//////////////////
// WEBPACK FOOTER
// ./static/js/catalogos.js
// module id = null
// module chunks = 